import { render, staticRenderFns } from "./Gallery5.vue?vue&type=template&id=f493afae&scoped=true&"
import script from "./Gallery5.vue?vue&type=script&lang=js&"
export * from "./Gallery5.vue?vue&type=script&lang=js&"
import style0 from "./Gallery5.vue?vue&type=style&index=0&id=f493afae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f493afae",
  null
  
)

export default component.exports